import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import DefaultLayout from "../../components/DefaultLayout";
import CarPurposeService from "../../apiServices/CarPurposeService";
import BottomPanel from "../../components/BottomPanel";
import { SelectField, TextField } from 'react-md';
import { notification } from 'antd';
import CarBrandService from "../../apiServices/CarBrandService";
import CarProductService from "../../apiServices/CarProductService";
import UserCarService from "../../apiServices/UserCarService";

class CreateNewCar extends Component {

    constructor(props){
        const urlParams = new URLSearchParams(window.location.search);
        const object_id = urlParams.get('id');
        const edit = urlParams.get('edit');

        super(props);
        this.state = {
            height: props.height,
            hasError: false,
            carPurpose: [],
            carNumberSeat: [],
            carBrands: [],
            carYears: [],
            carProducts: [],

            carPurposeSelect: null,
            carNumberSeatSelect: null,
            carBrandSelect: null,
            carYearSelect: null,
            carProductSelect: null,
            carAmount: '',
            showCarAmt: false,
            hiddenBtn: false,
            object_id: object_id,
            userCar: null,
            edit: edit,
        };
        this.loadCarPurpose();
    }

    componentDidMount() {
        this.setState({height: window.innerHeight + 'px'});
        if(this.state.object_id){
            UserCarService.detail(this.state.object_id).then(response=>{
                let x = Number(response.data.car_amount);
                let cAmount = x.toLocaleString('en');
                this.setState({
                    userCar: response.data,
                    carPurposeSelect: response.data.car_purpose_id,
                    carBrandSelect: response.data.car_brand_id,
                    carProductSelect: response.data.car_product_id,
                    carNumberSeatSelect: response.data.car_number_seat,
                    carYearSelect: response.data.car_year,
                    carAmount: cAmount,
                });
                this.loadCarProduct(response.data.car_brand_id);
            }).catch(function(error){
                console.log(error);
            });
        }else{
            this.props.history.push('/');
        }

        CarBrandService.getList().then(response => {
            this.setState({carBrands: response.data});
        }).catch(function(error){
            console.log(error);
        });


    }

    carPurposeChange = (value) => {
        this.setState({carPurposeSelect: value});
    };

    loadCarPurpose(){
        CarPurposeService.getList().then(response => {
            this.setState({carPurpose: response.data});
        }).catch(function(error){
            console.log(error);
        });
    }

    loadCarProduct(brand_id){
        CarProductService.getListByBrand(brand_id).then(response => {
            this.setState({carProducts: response.data});
        }).catch(function(error){
            console.log(error);
        });
    }

    carBrandSelect = (e) => {
        if (this.state.carPurposeSelect == null){
            notification['error']({
                message: 'Bạn phải chọn Mục đích sử dụng trước',
                description: '',
            });
        }
    };
    carBrandChange = (value) => {
        this.setState({carBrandSelect: value});
    };

    carYearSelect = (e) => {
        if (this.state.carProductSelect == null){
            notification['error']({
                message: 'Bạn chưa chọn dòng xe',
                description: '',
            });
        }else{
            CarProductService.getDetail(this.state.carProductSelect).then(response => {
                let x = Number(response.data.price);
                let cAmount = x.toLocaleString('en');
                this.setState({
                    carYears: JSON.parse(response.data.years),
                    carAmount: cAmount,
                    carNumberSeatSelect: response.data.number_seats,
                    showCarAmt: true
                });
            }).catch(function(error){
                console.log(error);
            });
        }
    };
    carYearChange = (value) => {
        this.setState({carYearSelect: value});
    };

    carProductSelect = (e) => {
        if (this.state.carBrandSelect == null){
            notification['error']({
                message: 'Bạn chưa chọn Hãng xe',
                description: '',
            });
        }else{
            CarProductService.getListByBrand(this.state.carBrandSelect).then(response => {
                this.setState({carProducts: response.data});
            }).catch(function(error){
                console.log(error);
            });
        }
    };
    carProductChange = (value) => {
        this.setState({carProductSelect: value});
    };

    carAmountChange = (value) => {
        let val = value.replace(/,/g, "");
        if(isNaN(val)){
            this.setState({carAmount: ''});
        }else {
            let x = Number(val);
            let cAmount = x.toLocaleString('en');
            this.setState({carAmount: cAmount});
        }
    };

    formSubmit = () => {
        if (this.state.carPurposeSelect==null){
            notification['error']({
                message: 'Bạn chưa chọn Mục đích sử dụng',
                description: '',
            });
        }else if (this.state.carBrandSelect == null){
            notification['error']({
                message: 'Bạn chưa chọn hãng xe',
                description: '',
            });
        }else if (this.state.carYearSelect == null){
            notification['error']({
                message: 'Bạn chưa chọn Năm sản xuất',
                description: '',
            });
        }else if (this.state.carProductSelect == null){
            notification['error']({
                message: 'Bạn chưa chọn Dòng xe',
                description: '',
            });
        }else if (this.state.carAmount === 0){
            notification['error']({
                message: 'Bạn chưa điền Giá trị xe',
                description: '',
            });
        }else{
            let amount = this.state.carAmount.replace(/,/g, "");
            amount = (amount==='')?0:amount;

            const data = {
                'id': this.state.object_id,
                'purpose_id': this.state.carPurposeSelect,
                'number_seat': this.state.carNumberSeatSelect,
                'brand_id': this.state.carBrandSelect,
                'issue_year': this.state.carYearSelect,
                'product_id': this.state.carProductSelect,
                'car_amount': amount,
                'insu_amount': amount
            };
            UserCarService.updateInfo(data).then(response => {
                if(this.state.edit){
                    this.props.history.push('/chi-tiet-xe?id='+response.data.id);
                }else{
                    this.props.history.push('/update-thong-tin-xe?id='+response.data.id);
                }
            }).catch(error => {
                notification.error({
                    message: 'Lỗi lưu thông tin',
                    description: JSON.stringify(error),
                });
            });
        }
    };

    render() {
        return (
            <div className='App-block bgWhite' style={{minHeight: this.state.height}}>
                <DefaultLayout {...this.props} title="Nhập thông tin xe" classNameContent="bgWhite" page_type={1} hiddenFt={true}>
                    <div className="wrap-content">
                        <SelectField
                            id="select-field-1"
                            label="Mục đích sử dụng"
                            placeholder="Mục đích sử dụng"
                            itemLabel="title"
                            itemValue="id"
                            className="md-cell md-cell--12"
                            menuItems={this.state.carPurpose}
                            sameWidth
                            onChange={this.carPurposeChange}
                            value={this.state.userCar? this.state.userCar.car_purpose_id:''}
                            position={SelectField.Positions.BOTTOM_LEFT}
                        />
                        <SelectField
                            id="select-field-4"
                            label="Hãng xe"
                            placeholder="Hãng xe"
                            itemLabel="name"
                            itemValue="id"
                            menuItems={this.state.carBrands}
                            className="md-cell md-cell--12"
                            sameWidth
                            onChange={this.carBrandChange}
                            onClick={this.carBrandSelect}
                            value={this.state.userCar? this.state.userCar.car_brand_id:''}
                            position={SelectField.Positions.BOTTOM_LEFT}
                        />
                        <SelectField
                            id="select-field-6"
                            label="Dòng xe"
                            placeholder="Dòng xe"
                            itemLabel="name"
                            itemValue="id"
                            menuItems={this.state.carProducts}
                            className="md-cell md-cell--12"
                            sameWidth
                            onChange={this.carProductChange}
                            onClick={this.carProductSelect}
                            value={this.state.carProductSelect? this.state.carProductSelect:''}
                            position={SelectField.Positions.BOTTOM_LEFT}
                        />
                        <SelectField
                            id="select-field-5"
                            label="Năm sản xuất"
                            placeholder="Năm sản xuất"
                            menuItems={this.state.carYears}
                            className="md-cell md-cell--12"
                            sameWidth
                            onChange={this.carYearChange}
                            onClick={this.carYearSelect}
                            position={SelectField.Positions.BOTTOM_LEFT}
                        />

                        <TextField
                            id="car-amount"
                            label="Giá trị xe"
                            className="md-cell md-cell--12"
                            onChange={e => this.carAmountChange(e)}
                            value={this.state.carAmount}
                        />
                    </div>
                </DefaultLayout>
                <BottomPanel handleClick={this.formSubmit} hidden={this.state.hiddenBtn} title={"Tiếp tục"} actionType='summit'/>
            </div>
        )
    }
}

export default (withTranslation())(CreateNewCar);
